export enum JoinMemberMode {
  recharge_join = "recharge_join",
  free_join = "free_join",
  annual_fee_join = "annual_fee_join",
}


export enum RechargeType {
  join_member_recharge_fee = "join_member_recharge_fee",
  normal_gift_card_recharge = "normal_gift_card_recharge",
  join_member_annual_fee = "join_member_annual_fee",
}

export const sourceMap = new Map([
  ["instant", "loyalty_web"],
  ["smart_ordering", "qr_code_ordering"],
  ["kiosk", "kiosk"],
]);